import React from "react";
import { Link } from "react-router-dom";
import Icon from "src/components/Icon/Icon";
import { propertymarkArticle } from "src/data/propertymarkArticle";

function formatDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export default function PropertymarkBanner(): JSX.Element {
  return (
    <section className="bg-text-obsidian text-white border-y border-solid border-[rgba(255,196,0,0.35)]">
      <Link
        to={`/news/${propertymarkArticle.slug}`}
        className="group block max-w-[1440px] mx-auto px-[5%] py-4 md:py-5 no-underline text-inherit hover:bg-[rgba(255,196,0,0.08)] transition-colors"
      >
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-6">
          <div className="flex items-start md:items-center gap-3 min-w-0">
            <span className="shrink-0 font-manrope text-[10px] uppercase tracking-[0.2em] bg-brand-yellow text-text-obsidian px-2 py-1">
              News
            </span>
            <div className="min-w-0">
              <p className="font-teko text-lg md:text-xl uppercase leading-tight group-hover:text-brand-yellow transition-colors">
                {propertymarkArticle.title}
              </p>
              <p className="font-manrope text-xs text-white/70 mt-1 line-clamp-2 md:line-clamp-1">
                {formatDate(propertymarkArticle.date)} · {propertymarkArticle.venue}
              </p>
            </div>
          </div>
          <span className="inline-flex items-center gap-2 font-manrope text-xs uppercase tracking-wider text-brand-yellow shrink-0 group-hover:gap-3 transition-all">
            Read article
            <Icon name="arrow_forward" size={16} />
          </span>
        </div>
      </Link>
    </section>
  );
}
